import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=590ae888&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "@/static/css/layout/footer.css?vue&type=style&index=0&id=590ae888&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ae888",
  null
  
)

export default component.exports